import * as React from 'react';
import React__default, { useEffect } from 'react';
import _s, { css } from 'styled-components';
import useTheme$1 from './useTheme.js';
import Box from './Box.js';
import Button from './Button.js';
import Icon from './Icon.js';
import Overlay from './Overlay.js';
import Portal from './Portal.js';
import { g as generateUtilityClass, s as styled$1, c as capitalize, a as _extends, _ as _objectWithoutPropertiesLoose, j as jsxRuntimeExports, b as clsx, P as PropTypes, e as composeClasses } from './styled-722a6242.js';
import { u as useThemeProps } from './useThemeProps-624634df.js';
import { g as generateUtilityClasses } from './generateUtilityClasses-06dec860.js';
import { u as useTheme } from './useTheme-3df06c17.js';
import { B as Backdrop, M as Modal$1, P as Paper, F as Fade } from './Paper-f4dae82d.js';
import { u as useId } from './useId-748eec35.js';
import LinkButton from './LinkButton.js';
import Typography from './Typography.js';
import useMediaQuery from './useMediaQuery.js';
import './darken-303c3324.js';
import './_commonjsHelpers-357b3b4e.js';
import './LoadingIndicator.js';
import './core.esm-901288dd.js';
import './inheritsLoose-6f2ea841.js';
import './global-2e5d81b9.js';
import 'react-dom';
import './index-a67b9a05.js';
import './getThemeProps-582952b7.js';
import './utils-c09c4ec9.js';
import './useSlotProps-263f7ba4.js';
import './objectWithoutPropertiesLoose-6737dabb.js';
import './index-5fd269e1.js';
import './index-48edd52c.js';
import './TransitionGroupContext-42c2fd98.js';
import './useEnhancedEffect-22d6b63a.js';
import './ownerWindow-b54d1bab.js';
import './Portal-4e916b93.js';
import './exactProp-86bc0113.js';

function getDialogUtilityClass(slot) {
  return generateUtilityClass('MuiDialog', slot);
}
const dialogClasses = generateUtilityClasses('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
var dialogClasses$1 = dialogClasses;

const DialogContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  DialogContext.displayName = 'DialogContext';
}
var DialogContext$1 = DialogContext;

const _excluded = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
const DialogBackdrop = styled$1(Backdrop, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});
const useUtilityClasses = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${capitalize(scroll)}`],
    paper: ['paper', `paperScroll${capitalize(scroll)}`, `paperWidth${capitalize(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return composeClasses(slots, getDialogUtilityClass, classes);
};
const DialogRoot = styled$1(Modal$1, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = styled$1('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${capitalize(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => _extends({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&:after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = styled$1(Paper, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${capitalize(ownerState.scroll)}`], styles[`paperWidth${capitalize(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => _extends({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11
}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
const Dialog$1 = /*#__PURE__*/React.forwardRef(function Dialog(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = useTheme();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      'aria-describedby': ariaDescribedby,
      'aria-labelledby': ariaLabelledbyProp,
      BackdropComponent,
      BackdropProps,
      children,
      className,
      disableEscapeKeyDown = false,
      fullScreen = false,
      fullWidth = false,
      maxWidth = 'sm',
      onBackdropClick,
      onClose,
      open,
      PaperComponent = Paper,
      PaperProps = {},
      scroll = 'paper',
      TransitionComponent = Fade,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const ownerState = _extends({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });
  const classes = useUtilityClasses(ownerState);
  const backdropClick = React.useRef();
  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };
  const handleBackdropClick = event => {
    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }
    backdropClick.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const ariaLabelledby = useId(ariaLabelledbyProp);
  const dialogContextValue = React.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(DialogRoot, _extends({
    className: clsx(classes.root, className),
    closeAfterTransition: true,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: _extends({
        transitionDuration,
        as: BackdropComponent
      }, BackdropProps)
    },
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/jsxRuntimeExports.jsx(DialogContainer, {
        className: clsx(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/jsxRuntimeExports.jsx(DialogPaper, _extends({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: clsx(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/jsxRuntimeExports.jsx(DialogContext$1.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Dialog$1.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': PropTypes.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': PropTypes.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: PropTypes.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]), PropTypes.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: PropTypes.oneOf(['body', 'paper']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes.object
} : void 0;
var Dialog$2 = Dialog$1;

const Modal = ({
  children,
  onRequestToClose,
  overlayTestID,
  visible,
  withPortal = true
}) => {
  const [theme] = useTheme$1();
  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      onRequestToClose();
    }
  };
  useEffect(() => {
    if (visible) {
      window.addEventListener('keydown', handleKeyDown);
    } else {
      window.removeEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible]);
  useEffect(() => {
    if (withPortal && visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'initial';
    }
    return () => {
      document.body.style.overflow = 'initial';
    };
  }, [visible, withPortal]);
  return withPortal ? /*#__PURE__*/React__default.createElement(Portal, {
    selector: "#kyte-portal"
  }, visible && /*#__PURE__*/React__default.createElement(Overlay, {
    onPress: onRequestToClose,
    testID: overlayTestID
  }), children) : /*#__PURE__*/React__default.createElement(Dialog$2, {
    open: visible,
    onClose: onRequestToClose,
    style: {
      zIndex: theme.zIndices.modal
    }
  }, children);
};

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Dialog = ({
  children,
  secondaryCtaOnPress,
  secondaryCtaText,
  secondaryCtaBtn = false,
  closeButtonTestID,
  closeIconName = '24-close-big',
  ctaText,
  onCtaPress,
  onRequestToClose,
  overlayTestID,
  size = 'small',
  testID,
  titleText,
  visible,
  withPortal = true,
  variant = 'dialog',
  loading = false,
  loadingSecondaryCta = false,
  paddingHorizontal = 'small',
  containerOverflow = true
}) => {
  const widthMapper = {
    small: '420px',
    medium: '540px',
    large: '800px'
  };
  const [theme] = useTheme$1();
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.sm})`);
  const showSecondaryCtaText = secondaryCtaText && !secondaryCtaBtn && secondaryCtaOnPress;
  return /*#__PURE__*/React__default.createElement(Modal, {
    visible: visible,
    onRequestToClose: onRequestToClose,
    overlayTestID: overlayTestID,
    withPortal: withPortal
  }, visible && /*#__PURE__*/React__default.createElement(Container, {
    style: {
      overflow: containerOverflow ? 'auto' : 'visible'
    },
    onClick: onRequestToClose,
    "data-testid": testID
  }, /*#__PURE__*/React__default.createElement(Inner, {
    "$variant": variant,
    "$width": widthMapper[size],
    onClick: event => {
      event.stopPropagation();
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    paddingHorizontal: "small"
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flex: 1
  }, closeIconName && /*#__PURE__*/React__default.createElement(Box, {
    onPress: onRequestToClose,
    cursor: "pointer",
    testID: closeButtonTestID
  }, /*#__PURE__*/React__default.createElement(Icon, {
    color: "primary",
    name: closeIconName
  }))), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center"
  }, titleText && /*#__PURE__*/React__default.createElement(Typography, {
    color: "primary",
    variant: "headline-3"
  }, titleText)), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flex: 1,
    justifyContent: "end",
    alignItems: "center"
  }, showSecondaryCtaText && /*#__PURE__*/React__default.createElement(LinkButton, {
    onPress: secondaryCtaOnPress
  }, secondaryCtaText))), /*#__PURE__*/React__default.createElement(Box, {
    marginTop: "small",
    height: "100%",
    paddingHorizontal: paddingHorizontal
  }, children), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: isMobile ? 'column' : 'row'
  }, ctaText && /*#__PURE__*/React__default.createElement(Box, {
    marginTop: "base",
    paddingLeft: "small",
    paddingRight: secondaryCtaBtn && !isMobile ? 'tiny' : 'small',
    width: !isMobile ? '100%' : 'auto'
  }, /*#__PURE__*/React__default.createElement(Button, {
    fullWidth: true,
    onPress: onCtaPress,
    loading: loading,
    loadingTestID: "dialog-loading",
    variant: "primary"
  }, ctaText)), secondaryCtaText && secondaryCtaBtn && /*#__PURE__*/React__default.createElement(Box, {
    marginTop: !isMobile ? 'base' : 'tiny',
    paddingLeft: secondaryCtaBtn && !isMobile ? 'tiny' : 'small',
    paddingRight: "small",
    width: !isMobile ? '100%' : 'auto'
  }, /*#__PURE__*/React__default.createElement(Button, {
    fullWidth: true,
    onPress: secondaryCtaOnPress,
    loading: loadingSecondaryCta,
    loadingTestID: "dialog-secondary-loading",
    variant: "secondary"
  }, secondaryCtaText))))));
};
const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${({
  theme
}) => theme.zIndices.modal};
`;
const Inner = styled.div`
  border-radius: ${({
  theme,
  $variant
}) => $variant === 'alert' ? theme.borderRadius.base : 0}px;
  height: ${({
  $variant
}) => $variant === 'alert' ? 'auto' : '100%'};
  margin-left: ${({
  $variant,
  theme
}) => $variant === 'alert' ? theme.spacings.small : 0}px;
  margin-right: ${({
  $variant,
  theme
}) => $variant === 'alert' ? theme.spacings.small : 0}px;
  max-height: initial;
  width: 100%;

  @media (min-width: ${({
  theme
}) => theme.breakpoints.sm}) {
    border-radius: ${({
  theme
}) => theme.borderRadius.large}px;
    height: initial;
    max-height: 680px;
    width: ${({
  $width
}) => $width};
  }

  ${({
  theme
}) => css(["background:", ";box-shadow:", ";box-sizing:border-box;display:flex;flex-direction:column;overflow-y:auto;padding:", "px 0;transition:all 0.1s ease-out;"], theme.backgroundColors.primary, theme.boxShadows.base, theme.spacings.base)}
`;

export { Dialog as default };
//# sourceMappingURL=Dialog.js.map
